import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M7.076 11.576a.6.6 0 0 1 .848 0L10.5 14.15l5.576-5.575a.6.6 0 0 1 .848.848l-6 6a.6.6 0 0 1-.848 0l-3-3a.6.6 0 0 1 0-.848ZM12 20.8a8.8 8.8 0 1 0 0-17.6 8.8 8.8 0 0 0 0 17.6ZM22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      clip-rule="evenodd"
    />
  </svg>
`;
